export default {
    addBusiness: 'Add Business',
    list: {
        title: 'Business List',
        description: 'Manage your business listings',
        noDataFound: 'No businesses found',
        viewAnalytics: 'View Analytics',
        previous: 'Previous',
        next: 'Next',
    },
    create: {
        title: 'Create Business',
        description: 'Add a new business listing',
        createBusiness: 'Create Business',
        form: {
            coverPhotos: {
                title: 'Cover Photos',
                addMorePhotos: 'Add more photos +',
                onSuccessDeletePhoto: {
                    title: 'Photo Deleted',
                    message: 'The photo has been deleted successfully.',
                },
                dropzone: {
                    title: 'Drag & drop images here',
                    subtitle: 'or click to select files',
                    supportedFileTypes: 'JPG, JPEG, PNG supported',
                    dragAcceptTitle: 'Perfect! Drop your images',
                    dragAcceptSubtitle: 'These files are ready to upload',
                    dragRejectTitle: 'Invalid file type',
                    dragRejectSubtitle: 'Please drop only image files',
                    dragActiveTitle: 'Drop your images here',
                    dragActiveSubtitle: 'Release to upload your files',
                    clearAll: 'Clear all',
                    upload: 'Upload',
                    selectedFiles_one: '{{count}} image selected',
                    selectedFiles_other: '{{count}} images selected',
                },
            },
            businessDetails: {
                title: 'Business Details',
                name: 'Name',
                email: 'Email',
                phone: 'Phone number',
                businessAddress: 'Business Address',
                description: 'Description',
                selectACategory: 'Select a Category',
                phoneNumber: 'Phone Number',
            },
            offers: {
                title: 'Offers',
                offer: 'Offer',
                description: 'Description',
                reward: 'Reward',
                minFollowers: 'Minimum Followers',
                requiredStoryCount: 'Required Story Count',
                addOffer: 'Add Offer',
            },
            businessHours: {
                title: 'Business Hours',
                monday: 'Monday',
                tuesday: 'Tuesday',
                wednesday: 'Wednesday',
                thursday: 'Thursday',
                friday: 'Friday',
                saturday: 'Saturday',
                sunday: 'Sunday',
                open: 'Open',
                close: 'Close',
            },
            onSuccessApproval: {
                title: 'Business Approved',
                message: 'The business has been approved successfully.',
            },
            onSuccessEditting: {
                title: 'Business Edited',
                message: 'The business has been edited successfully.',
            },
        },
        formErrors: {
            name: 'Enter your business name',
            category: 'Pick at least one category',
            description: {
                en: 'Add an English description of at least 5 characters',
                fr: 'Add a French description of at least 5 characters',
            },
            phone: 'Enter a phone number',
            emailInvalid: 'Enter a valid email, like contact@yourbusiness.com',
            phoneInvalid: 'Enter a valid phone number, like 514 555-5555',
            websiteInvalid: 'Enter a valid website, like www.yourbusiness.com',
            coverPhotos: 'Add at least one photo of your business',
            location: {
                lat: 'Pick your address from the suggestions so we can map it',
                lng: 'Pick your address from the suggestions so we can map it',
            },
            offers: {
                atLeastOne: 'Add at least one offer',
                reward: 'Describe what the influencer gets, in English and French',
                minFollowers: 'Set a follower minimum of at least 1',
                requiredStoryCount: 'Ask for at least one story or reel',
                category: 'Pick a category for this offer',
            },
            businessHours: 'Turn on at least one day influencers can visit',
            owner: 'This business needs an owner',
            place: 'Start typing your address and pick it from the suggestions',
        },
    },
    details: {
        title: 'Business Details',
        description: 'View and manage business details',
        unapprovedBusiness: {
            title: 'Approval requested',
            checkButtonTooltip: 'Approve business',
            deleteButtonTooltip: 'Reject business',
        },
        approvedBusiness: {
            title: 'Active businesses',
        },
    },
    approveBusiness: 'Approve Business',
    approved: 'Approved',
    pendingApproval: 'Pending Approval',
    analytics: {
        title: 'Analytics',
        pie: {
            accepted: 'Accepted',
            rejected: 'Rejected',
            canceled: 'Canceled',
            archived: 'Archived',
            pending: 'Pending',
            title: 'Claims Overview',
            total: 'Total claims',
            influencers: 'Influencers',
            businesses: 'Businesses',
            usersTitle: 'Users data',
        },
        table: {
            title: 'Unanswered claims (pending 5+ days)',
            business: 'Business',
            totalClaims: 'Total Claims',
            unanswered: 'Unanswered',
            unansweredPercentage: 'Unanswered %',
        },
    },
};
